import { Icon } from '@factorialco/deprecated-design-system'

export interface Source {
  [key: string]: {
    key: string
    title: string
  }
}

export enum ChangeType {
  Tag = 'tag',
  Comment = 'comment',
  Updates = 'updates',
}

export enum ChangeValueType {
  Text = 'text',
  Tag = 'tag',
  Avatar = 'avatar',
}

export interface ChangeValue {
  value: string | number | boolean
  type: ChangeValueType
}
export interface Change {
  change: {
    title: string
    value?: ChangeValue
    old_value?: ChangeValue
    icon?: React.ComponentProps<typeof Icon.Medium>['icon']
    link?: string
    type?: ChangeType
  }
}
